import React, { ChangeEvent } from 'react';
import banner from '../../Images/banner.png';
import './Login.css';
import { Button, TextField, Typography, buttonBaseClasses } from '@mui/material';
import Box from '@mui/material/Box';
import ValidationCheck from '../../Common/Validation/ValidationChecks';
import BigButton from '../../Component/BigButton';
import { ShowAlert } from '../../Component/ShowAlert';
import LoginServices from '../../Services/LoginServices';
import { loadFromLocalStorage, saveToLocalStorage } from '../../Common/Validation/LocalStorage';
import AddCardService from '../../Services/AddCardService';
import WarningIcon from '@mui/icons-material/Warning';
import { SyncContext, SyncContextType } from '../../Contexts/BatchSyncContext';
import UserAndPermissionService from '../../Services/UserAndPermissionService';
import { Permissions } from '../../Component/Permissions/PermissionsInterface.';

interface LoginProps {}
interface LoginState {
    email: string;
    otp: string;
    showOTPView: boolean;
    isEmailfocussed: boolean;
    isOtpFocussed: boolean;

}

class Login extends React.Component<LoginProps, LoginState> {
    static contextType = SyncContext;
    context!: SyncContextType;
    constructor(props: LoginProps) {
        super(props);
        this.state = {
            email: '',
            otp: '',
            showOTPView: false,
            isEmailfocussed: false,
            isOtpFocussed: false
        }
    }

    async componentDidMount() {
        const accesstoken = await loadFromLocalStorage('accessToken');

        if (accesstoken) {
            this.getUserDetails(accesstoken.toString());
        }
    }




    handleResend = () => {

    };

    handleChangeEmail = () => {
        // Logic to handle email change
    }
    private isNumber(evt: any) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode >= 96 && charCode <= 105)) {
            evt.preventDefault();
        }
    }
    private formatCardNumber(evt: any) {
        let value = evt.target.value.replace(/\D/g, ''); // Remove all non-digit characters
        value = value.match(/.{1,4}/g)?.join(' ') || value; // Add spaces every 4 digits
        evt.target.value = value;
        console.log("value", value);
    }

    handleSendOTP = () => {
        if (ValidationCheck.validateEmail(this.state.email)) {
            const postData = { email: this.state.email };
            LoginServices.sendOTP(postData).then(response => {
                if (response.ok) {
                    this.setState({ showOTPView: true });
                } else {
                    ShowAlert("PassportPay", "Something went wrong", 'error');
                }
            });
        }
    }


    public render() {
        return (
            <div className='login-parent-container'>
                <form className="login-container" id="userDetails" onSubmit={(event) => { event.preventDefault(); }}>
                    <div className="imgcontainer">
                        <img src={banner} alt="Avatar" className="avatar" />
                    </div>
                    <div className='login-title'>Sign in</div>
                    <div className='login-sub-header'>Sign in to access your account</div>
                    <div className="login-form-body">
                        <div className='login-email-container'>
                            <div style={{ display: 'flex', flexDirection: 'column', padding: '10px 30px 10px 30px' }}>
                                {
                                    this.state.showOTPView ? <>
                                        <p style={{ textAlign: 'left', margin: '5px 0px' }}>
                                            Enter your OTP
                                        </p>
                                        <TextField
                                            placeholder='Your OTP'
                                            variant="outlined"
                                            color="primary" // Use the primary color
                                            value={this.state.otp}
                                            onChange={(event) => {
                                                const value = event.target.value;
                                                const numericValue = value.replace(/[^0-9]/g, '');

                                                this.setState({
                                                    isOtpFocussed: true
                                                }, () => {
                                                    if (numericValue.length <= 6) {
                                                        this.setState({ otp: numericValue });
                                                    }
                                                });
                                            }}
                                            style={{ padding: '5px 0px' }}
                                            inputProps={{ maxLength: 6, inputMode: 'numeric', pattern: '[0-9]*' }}
                                            className='web-input-field'
                                        />
                                        {
                                            (this.state.isOtpFocussed && this.state.otp == "") && <div className='error-msg'><WarningIcon /> Please enter the OTP</div>
                                        }

                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                            <p style={{ textAlign: 'center' }}>
                                                Didn't get the OTP?
                                            </p>
                                            <Button style={{ 'backgroundColor': 'white', color: '#67d01c', width: 'auto', height: 'auto', textTransform: 'capitalize' }} onClick={() => {
                                                if (ValidationCheck.validateEmail(this.state.email)) {
                                                    const postData = {
                                                        email: this.state.email
                                                    }
                                                    LoginServices.sendOTP(postData).then(response => {
                                                        if (response.ok) {
                                                            ShowAlert("PassportPay", "The OTP has been resent", 'success')
                                                        } else {
                                                            ShowAlert("PassportPay", "Something went wrong", 'error')
                                                        }
                                                    })
                                                } else {
                                                    ShowAlert("PassportPay", this.state.email == "" ? "Please enter the email" : "Please enter the valid email address", 'error')
                                                }
                                            }}>Resend</Button>
                                        </div>

                                        <BigButton
                                            disabled={this.state.otp == ""}
                                            onClick={() => {
                                                const postData = {
                                                    email: this.state.email,
                                                    otp: this.state.otp
                                                }

                                                LoginServices.verifyOTP(postData).then(response => {
                                                    if (response.ok) {
                                                        return response.json();
                                                    } else {
                                                        throw new Error("Network response was not ok.");
                                                    }
                                                })
                                                    .then(async data => {
                                                        const accessToken = data.accessToken;
                                                        console.log(accessToken);
                                                        saveToLocalStorage('accessToken', accessToken);
                                                        const LoadAccesstoken = await loadFromLocalStorage('accessToken');
                                                        console.log("LoadAccesstoken", LoadAccesstoken);
                                                        this.getUserDetails(accessToken.toString());

                                                        // window.location.href = '/dashboard';
                                                        // You can now use the accessToken as needed
                                                    })
                                                    .catch(error => {
                                                        console.error("There was a problem with the fetch operation:", error);
                                                    });

                                            }} buttonText="Continue" />

                                    </>
                                        :
                                        <>
                                            <p style={{ textAlign: 'left', margin: '5px 0px' }}>
                                                Enter your email address
                                            </p>
                                            {/* <Box
                                                component="form"
                                                noValidate
                                                autoComplete="off"
                                            >
                                                <TextField
                                                    id="outlined-basic" label="Enter your email address *" variant="outlined"
                                                    // placeholder='Your email *'
                                                    // variant="outlined"
                                                    color="primary" // Use the primary color
                                                    value={this.state.email}
                                                    onChange={(text) => {
                                                        this.setState({ isEmailfocussed: true, email: text.target.value });
                                                    }}
                                                    className='web-input-field'
                                                />
                                            </Box> */}
                                            <TextField
                                                placeholder='Your email *'
                                                variant="outlined"
                                                color="primary"
                                                value={this.state.email}
                                                onChange={(text) => {
                                                    this.setState({ isEmailfocussed: true, email: text.target.value });
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter" && ValidationCheck.validateEmail(this.state.email)) {
                                                        this.handleSendOTP();
                                                    }
                                                }}
                                                className='web-input-field'
                                            />

                                            {
                                                (this.state.isEmailfocussed && this.state.email !== "" && !ValidationCheck.validateEmail(this.state.email)) &&
                                                <div className="error-msg"><WarningIcon /> Please enter a valid email address</div>
                                            }

                                            {
                                                (this.state.isEmailfocussed && this.state.email === "") &&
                                                <div className='error-msg'><WarningIcon /> Please enter the email</div>
                                            }
                                            <BigButton
                                                buttonText='Send OTP'
                                                disabled={!ValidationCheck.validateEmail(this.state.email)}
                                                onClick={this.handleSendOTP}
                                            />
                                        </>
                                }
                            </div>

                        </div>
                    </div>
                </form>
            </div>
        )
    }

    private generateRoutes = (permissions: Permissions) => {
        const routes: string[] = [];

        if (permissions.dashboard?.isVisible) routes.push("/dashboard");
        if (permissions.transactionLogs?.isVisible) routes.push("/transactionlogs");
        if (permissions.complianceLogs?.isVisible) routes.push("/compliance");
        if (permissions.userDetails?.isVisible) routes.push("/userdetails");
        if (permissions.userTransactionReport?.isVisible) routes.push("/userreports");
        if (permissions.userLogs?.isVisible) routes.push("/useractions");
        if (permissions.promoCode?.isVisible) routes.push("/promocode");
        if (permissions.exchangeRates?.isVisible) routes.push("/exchangerate");
        if (permissions.referrals?.isVisible) routes.push("/referral");
        if (permissions.partner?.isVisible) routes.push("/partner");
        if (permissions.ratereconciliation?.isVisible) routes.push("/ratereconciliation");
        if (permissions.fxReports?.isVisible) routes.push("/fxreports");

        return routes;
    };

    // Get user and related permisisons and route based on that....
    private getUserDetails = async (accessToken: string) => {
        try {
            // Fetch user details
            const userResponse = await AddCardService.getUserDetails(accessToken);

            if (!userResponse.ok) {
                console.error("Failed to fetch user details. Clearing storage.");
                localStorage.clear();
                return;
            }

            const userProfile = await userResponse.json();
            saveToLocalStorage("profile", userProfile);

            let permissionResponse;

            if (!userProfile?.roleId) {
                //This is for the admin user all permission allowd.....
                permissionResponse = {
                    permissions: {
                        profileSettings: {
                            isExchangeRateVisible: true,
                            isExchangeRateSaveBtnVisible: true,
                            isGeneralSettingsVisible: true,
                            isGeneralSettingSaveBtnVisible: true,
                            isPauseTransactionVisible: true,
                            isCardVerification: true,
                        },
                        dashboard: {
                            isVisible: true,
                            isHeaderVisible: true,
                            isTransactionMetricsVisible: true,
                            isFinancialMetricsVisible: true,
                            isRiskMetricsVisible: true,
                            isSupportMetricsVisible: true,
                            isPerformanceMetricsVisible: true,
                        },
                        transactionLogs: {
                            isVisible: true,
                            isDownloadVisible: true,
                            isFraudMarkVisible: true,
                            isRefundVisible: true,
                        },
                        userLogs: {
                            isVisible: true,
                        },
                        complianceLogs: {
                            isVisible: true,
                            isZendeskNavigationAllowed: true,
                            isTransactionNavigationAllowed: true,
                        },
                        userDetails: {
                            isVisible: true,
                            isAdminTabVisible: true,
                            isUsersTabVisible: true,
                            isSupportRolesTabVisible: true,
                            isBlockUserVisible: true,
                            isUserSettingsVisible: true,
                            isUserSettingSaveBtnVisible: true,
                            isStatusHistoryVisible: true,
                            isUpdatePermissionVisible: true,
                            isAdminDownloadVisible: true,
                            isUserDownloadVisible: true,
                            isSupportRoleDownloadVisible: true,
                            isEditUserInfoVisible: true,
                        },
                        userTransactionReport: {
                            isVisible: true,
                            isDownloadVisible: true,
                            isLimitHistoryVisible: true,
                            isLimitHistoryDownloadVisible: true,
                        },
                        promoCode: {
                            isVisible: true,
                            isDownloadVisible: true,
                            isAddPromoCodeVisible: true,
                            isBlockCodeVisible: true,
                            isActiveCodeVisible: true
                        },
                        exchangeRates: {
                            isVisible: true,
                            isDownloadVisible: true,
                            isAddCurrencyPairVisible: true,
                            isEditRatesVisible: true,
                            isEditPaymentMethodVisible: true,
                            isActiveCurrencyAllowed: true,
                            isInactiveCurrencyAllowed: true
                        },
                        referrals: {
                            isVisible: true,
                            isDownloadVisible: true,
                            isReferralSettingsVisible: true,
                            isSaveSettingsAllowed: true,
                            isViewRefereesVisible: true,
                            isTransactionNavigationAllowed: true
                        },
                        chargeBack: {
                            isVisible: true,
                            isDownloadFileAllowed: true,
                            isSendEmailAllowd: true
                        },
                        partner: {
                            isVisible: true,
                            isDownloadVisible: true,
                            isAddLiquidityPartnerVisible: true,
                            isEditPartnersVisible: true,
                            isActivePartnersVisible: true,
                            isInActivePartnersVisible: true,
                        },
                        ratereconciliation: {
                            isVisible: true,
                        },
                        fxAllocation: {
                            isVisible: true,
                            isCreatePurchaseVisible: true,
                            isCreateLiquidityVisible: true,
                            isCreatePartnerVisible: true
                        },

                    }
                }
            } else {
                //Fetch permissions
                const permissionResponseRaw = await UserAndPermissionService.getPermissions(accessToken, userProfile.roleId);

                if (!permissionResponseRaw.ok) {
                    console.error("Failed to fetch permissions.");
                    localStorage.clear();
                    ShowAlert("PassportPay", "Unable to retrieve permissions. Please try again later.", "error");
                    return;
                }

                permissionResponse = await permissionResponseRaw.json();
            }

            if (!permissionResponse?.permissions) {
                console.warn("Permission denied, logging out...");
                localStorage.clear();
                ShowAlert("PassportPay", "You don’t have any permissions. Please contact admin.", "error");
                return;
            }

            // Dispatch permission details to global context
            this.context.dispatch({ type: "SET_PERMISSION", payload: permissionResponse });

            // Generate accessible routes based on permissions
            const allowedRoutes = this.generateRoutes(permissionResponse.permissions);

            if (allowedRoutes.length === 0) {
                console.warn("No accessible routes. Logging out...");
                localStorage.clear();
                localStorage.removeItem("batch-info");
                ShowAlert("PassportPay", "You do not have permission to access any pages. Please contact the administrator for assistance.", "error");
                return;
            }

            const redirectURL = localStorage.getItem("redirectAfterLogin") || "";

            if (redirectURL && !permissionResponse.permissions.userDetails?.isVisible) {
                localStorage.clear();
                localStorage.removeItem("batch-info");
                ShowAlert("PassportPay", "You do not have access to requested page. Please contact the administrator for assistance.", "error");
                return;
            }

            const navigateTo = redirectURL || allowedRoutes[0];

            // Redirect to the first available allowed route or the redirect URL
            window.location.href = navigateTo;

        } catch (error) {
            console.error("Error in getUserDetails:", error);
            localStorage.clear();
        }
    };
}

export default Login;